import * as React from 'react';
import styled from 'styled-components';
import InformationTable from 'components/common/table/InformationTable';
import { InformationObject } from 'types/common/informationTable';
import classNames from 'classnames';
import { GetInvoiceDetailResponse } from 'types/plansales/invoice/invoiceDetail';
import { InvoiceDetailStatus } from 'types/plansales/billing/invoice';

interface Props {
  data: GetInvoiceDetailResponse;
}

/**
 * Invoice detail 페이지 중간의 Payment Info 영역
 * @param data
 * @constructor
 */
const InvoiceDetailPaymentInformation = ({ data }: Props) => {
  const isRefunded = data.status === InvoiceDetailStatus.Refund;
  const currency = '$'; // 추후 서버에서 받아서 변경
  const paymentInformation: InformationObject[] = [
    {
      title: 'Billed Amount (Including Tax)',
      render: (
        <PriceText className={classNames({ secondary: isRefunded })}>
          {`${currency} `} {(data.totalAmount + data.taxAmount)?.toFixed(2)}
        </PriceText>
      ),
      textAlign: 'right',
      titleWidth: '45%',
    },
    {
      title: 'Payment By Credit',
      render: (
        <PriceText className={classNames({ secondary: isRefunded })}>
          {`${currency} `}
          {data.creditAmount?.toFixed(2)}
        </PriceText>
      ),
      textAlign: 'right',
      titleWidth: '45%',
    },
    {
      title: 'Payment By Card (Including Tax)',
      render: (
        <PriceText className={classNames({ secondary: isRefunded })}>
          {`${currency} `}
          {data.cardAmount?.toFixed(2)}
        </PriceText>
      ),
      textAlign: 'right',
      titleWidth: '45%',
    },
  ];

  return <InformationTable title={'Payment'} data={paymentInformation} />;
};

export default InvoiceDetailPaymentInformation;

const PriceText = styled.span`
  &.secondary {
    text-decoration: line-through;
  }
`;
